













































































import { Component, Prop, Vue } from "vue-property-decorator";
import { returnSummaryInfo } from "@/api/order";

@Component
export default class HelloWorld extends Vue {
  @Prop() private fromDate!: string;
  @Prop() private productName!: string;
  @Prop() private shopName!: string;
  @Prop() private phone!: string;
  @Prop() private memberName!: string;
  @Prop() private expressNo!: number;
  @Prop() private orderStatus!: number;
  @Prop() private total!: number;

  // 构造器自有属性
  options: Array<any> = [
    {
      id: 1,
      label: "待发货",
    },
    {
      id: 2,
      label: "已发货",
    },
  ];
  sumInfo: {
    countOrder: number;
    orderSumCost: number;
  } = {
    countOrder: 0,
    orderSumCost: 0,
  };

  mounted() {
    returnSummaryInfo().then((res: any) => {
      this.sumInfo.countOrder = res.data.countOrder || 0;
      this.sumInfo.orderSumCost = res.data.orderSumCost || 0;
    });
  }
}
